import React from 'react';
import {
  Show,
  TabbedShowLayout,
  Tab,
  TextField,
  DateField,
  BooleanField,
  NumberField,

  FunctionField,
  ChipField,
} from 'react-admin';

const orderStatusChoices = [
  { id: 'PENDING', name: 'Ожидает' },
  { id: 'PROCESSING', name: 'Обрабатывается' },
  { id: 'SHIPPED', name: 'Отправлен' },
  { id: 'DELIVERED', name: 'Доставлен' },
  { id: 'CANCELLED', name: 'Отменен' },
];

const StatusChip = ({ record }: any) => {
  const statusChoice = orderStatusChoices.find(choice => choice.id === record.status);
  const getColor = (status: string) => {
    switch (status) {
      case 'PENDING': return 'warning';
      case 'PROCESSING': return 'info';
      case 'SHIPPED': return 'primary';
      case 'DELIVERED': return 'success';
      case 'CANCELLED': return 'error';
      default: return 'default';
    }
  };
  
  return (
    <ChipField 
      record={{ value: statusChoice?.name || record.status }} 
      source="value" 
      color={getColor(record.status)}
    />
  );
};

export const OrderShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Основная информация">
        <TextField source="id" label="ID заказа" />
        
        <TextField source="user.name" label="Клиент" />
        <TextField source="user.email" label="Email клиента" />
        
        <TextField source="supplement.name" label="Добавка" />
        <FunctionField 
          label="Цена за единицу"
          render={(record: any) => `$${record.supplement?.price?.toFixed(2) || '0.00'}`} 
        />
        
        <NumberField source="quantity" label="Количество" />
        <FunctionField 
          label="Общая сумма"
          render={(record: any) => `$${record.totalPrice?.toFixed(2) || '0.00'}`}
        />
      </Tab>

      <Tab label="Статус и даты">
        <FunctionField 
          label="Статус заказа"
          render={(record: any) => <StatusChip record={record} />}
        />
        <BooleanField source="isPaid" label="Заказ оплачен" />
        
        <DateField source="createdAt" label="Дата создания" showTime />
        <DateField source="updatedAt" label="Дата обновления" showTime />
        <DateField source="paidAt" label="Дата оплаты" showTime />
      </Tab>

      <Tab label="Контекст и рекомендации">
        <TextField source="challengeContext" label="Контекст челленджа" />
        <TextField source="recommendationReason" label="Причина рекомендации" />
      </Tab>

      <Tab label="Доставка">
        <TextField source="user.shippingCountry" label="Страна" />
        <TextField source="user.shippingCity" label="Город" />
        <TextField source="user.shippingAddress" label="Адрес" />
        <TextField source="user.shippingZipCode" label="Почтовый индекс" />
        <TextField source="user.shippingNotes" label="Примечания к доставке" />
        
        {/* Форматированный адрес */}
        <FunctionField 
          label="Полный адрес доставки"
          render={(record: any) => {
            const user = record.user;
            if (!user) return 'Пользователь не найден';
            
            const parts = [
              user.shippingCountry,
              user.shippingCity,
              user.shippingAddress,
              user.shippingZipCode
            ].filter(Boolean);
            
            if (parts.length === 0) return 'Адрес доставки не указан';
            
            return (
              <div style={{ lineHeight: '1.5' }}>
                <div><strong>{parts.join(', ')}</strong></div>
                {user.shippingNotes && (
                  <div style={{ marginTop: '8px', color: '#666' }}>
                    Примечания: {user.shippingNotes}
                  </div>
                )}
              </div>
            );
          }}
        />
        
        <FunctionField 
          label="Информация о трекинге (форматированная)"
          render={(record: any) => {
            try {
              if (record.trackingInfo) {
                const tracking = JSON.parse(record.trackingInfo);
                return (
                  <div>
                    {tracking.trackingNumber && <div>Номер: {tracking.trackingNumber}</div>}
                    {tracking.carrier && <div>Перевозчик: {tracking.carrier}</div>}
                    {tracking.status && <div>Статус: {tracking.status}</div>}
                    {tracking.estimatedDelivery && <div>Ожидаемая доставка: {tracking.estimatedDelivery}</div>}
                  </div>
                );
              }
              return 'Информация о трекинге отсутствует';
            } catch (e) {
              return record.trackingInfo || 'Информация о трекинге отсутствует';
            }
          }}
        />
      </Tab>

      <Tab label="Информация о добавке">
        <TextField source="supplement.name" label="Название" />
        <TextField source="supplement.description" label="Описание" />
        <FunctionField 
          label="Преимущества"
          render={(record: any) => record.supplement?.benefits?.join(', ') || 'Не указано'} 
        />
        <TextField source="supplement.duration" label="Длительность приема" />
        <TextField source="supplement.emoji" label="Эмодзи" />
        <FunctionField 
          label="Цена"
          render={(record: any) => `$${record.supplement?.price?.toFixed(2) || '0.00'}`} 
        />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
